import { useState } from 'react'
import { post } from '../../../../../utils/Api'
import { useGlobalContext } from '../../../../../utils/Context'
import FormLoader from '../../../../../components/loader/FormLoader'
import { Icon } from '@iconify/react'

interface Props {
  invoiceId: string
  totalAmount: number
  itemCount: number
  onClose: () => void
  onSuccess: () => void
}

function SendInvoiceModal({
  invoiceId,
  totalAmount,
  itemCount,
  onClose,
  onSuccess,
}: Props) {
  const { notify } = useGlobalContext()
  const [loading, setLoading] = useState(false)

  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('en-NG', {
      style: 'currency',
      currency: 'NGN',
    }).format(amount)
  }

  const handleSend = async () => {
    setLoading(true)

    try {
      const response = await post(
        'admin/weight-discrepancy/send-invoice',
        { invoiceId },
        null,
      )

      if (response.status === 200) {
        notify('success', 'Invoice sent successfully')
        onSuccess()
        onClose()
      } else {
        notify('error', response.message || 'Failed to send invoice')
      }
    } catch (error) {
      notify('error', 'Failed to send invoice')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className='modal-overlay'>
      <div className='modal-content'>
        <div className='modal-header'>
          <h2>Send Invoice</h2>
          <button className='close-btn' onClick={onClose}>
            <Icon icon='mdi:close' />
          </button>
        </div>

        <div className='modal-body'>
          <div
            style={{
              textAlign: 'center',
              padding: '20px 0',
            }}
          >
            <Icon
              icon='mdi:email-send'
              style={{
                fontSize: '64px',
                color: '#446ce4',
                marginBottom: '20px',
              }}
            />
            <h3 style={{ marginBottom: '10px' }}>Confirm Send Invoice</h3>
            <p style={{ color: '#666', marginBottom: '20px' }}>
              This will generate a PDF, email it to the customer, and start the
              7-day payment deadline.
            </p>
          </div>

          <div
            className='check-result'
            style={{ backgroundColor: '#f5f5f5', marginBottom: '20px' }}
          >
            <div className='result-row'>
              <span>Total Amount</span>
              <span style={{ color: '#446ce4', fontWeight: 600 }}>
                {formatCurrency(totalAmount)}
              </span>
            </div>
            <div className='result-row'>
              <span>Number of Items</span>
              <span>{itemCount}</span>
            </div>
            <div className='result-row'>
              <span>Payment Deadline</span>
              <span>7 days from now</span>
            </div>
          </div>

          <div
            style={{
              backgroundColor: '#fff3e0',
              padding: '15px',
              borderRadius: '8px',
              marginBottom: '20px',
            }}
          >
            <p style={{ margin: 0, fontSize: '14px', color: '#e65100' }}>
              <Icon
                icon='mdi:alert-circle'
                style={{ marginRight: '8px', verticalAlign: 'middle' }}
              />
              Once sent, the invoice cannot be modified. Make sure all items are
              correct.
            </p>
          </div>

          <div className='modal-actions'>
            <button className='btn-secondary' onClick={onClose}>
              Cancel
            </button>
            {loading ? (
              <FormLoader position='center' />
            ) : (
              <button className='btn-primary' onClick={handleSend}>
                <Icon icon='mdi:send' style={{ marginRight: '5px' }} />
                Send Invoice
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default SendInvoiceModal
